import React, { useState, useEffect,useRef } from "react";
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import SalespersonSidebar from "./SalespersonSidebar";
import './classes/EditProduct.css';
import Loading from './Loading';
import { configData } from "../config";
import { Helmet } from 'react-helmet';
import Editor from 'react-simple-wysiwyg';

const EditProduct = () => {

    const initialProductForm = {
        product_name:'',
        product_sku: '',
        product_price:'',
        product_price1:'',
        product_price2:'',
        relate_misc:'',
        relate_categories:'',
        product_type: '',
        files:[],
        weight:'',
        product_url_slug:'',
        size: false,
        sizes: [{ name: "", price: "" }],
        size_chart: "",
        package_sku:[],
        relate_package:'',
        product_status: '1',
        disclaimer_editor:'',
        removed_imageids:[],
        deleted_sizes: [],
    }
const defaultTable = `
  <table border="1" style="width:100%; border-collapse:collapse; text-align:center; font-size: 14px">
    
	<tbody>
		<tr>
			<th>Size</th>
			<th>Chest(in inches)</th>
			<th>Waist(in inches)</th>
		</tr>
		<tr>
			<td>Small</td>
			<td>34-36&quot;</td>
			<td>28-30&quot;</td>
		</tr>
		<tr>
			<td>Medium</td>
			<td>38-40&quot;</td>
			<td>32-34&quot;</td>
		</tr>
		<tr>
			<td>Large</td>
			<td>42-44&quot;</td>
			<td>36-38&quot;</td>
		</tr>
		<tr>
			<td>Extra Large</td>
			<td>46-48&quot;</td>
			<td>40-42&quot;</td>
		</tr>
	</tbody>


  </table>
`;
    const [savedProductType, setSavedProductType] = useState("");
    const [isLoading, setIsLoading] = useState(true); 
    const [savedData, setSavedData] = useState(initialProductForm);
    const [formData, setFormData] = useState(initialProductForm);
    const [errors, setErrors] = useState([]);  
    const [miscOptions, setMiscOptions] = useState({})
    const [packageOptions, setpackageOptions] = useState({})
    const [categories, setcategories] = useState({})
    const [relatepackage, setrelatepackage] = useState({}) 
    const [savedFiles, setSavedFiles] = useState([]);
 
    var {id} = useParams();
   
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    
//   useEffect(() => {
//     if (formData.size && formData.sizes.length === 0) {
//       setFormData(prev => ({
//         ...prev,
//         sizes: [{ name: "", price: "" }],
//       }));
//     }
//   }, []);
const handleChange = (e) => {
    const { name, type, checked, value, files } = e.target;

    let newValue;

    if (type === "file") {
        newValue = Array.from(files);
    } else if (type === "checkbox") {
        newValue = checked;

        if (name === "size") {
            if (checked) {
                // If checked and sizes is empty, add one default row
                setFormData(prev => ({
                    ...prev,
                    size: true,
                    sizes: prev.sizes.length === 0 ? [{ name: "", price: "" }] : prev.sizes,
                }));
            } else {
                // If unchecked, reset size and sizes
                setFormData(prev => ({
                    ...prev,
                    size: false,
                    // sizes: [],
                }));
            }
            return;
        }
    } else {
        newValue = value;
    }

    setFormData((prev) => ({
        ...prev,
        [name]: newValue,
    }));
};

    const onEditorChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const validatePriceInput = (value) => {
        const regex = /^\d*\.?\d*$/;
        return value === '' || regex.test(value);
    };
    const handlePriceChange = (event) => {
        const { name, value } = event.target;

        if (validatePriceInput(value)) {
            setFormData((prevPrices) => ({
                ...prevPrices,
                [name]: value
            }));
        }    
    };

    // const handleNumberLikeChange = (field, inputValue) => {
    //     // Remove existing commas
    //     let rawValue = inputValue.replace(/,/g, "");

    //     // Allow only digits and at most one period
    //     const regex = /^\d*\.?\d*$/;

    //     if (rawValue === "" || regex.test(rawValue)) {
    //     // Split integer and decimal parts
    //     const [integerPart, decimalPart] = rawValue.split(".");

    //     // Add commas to integer part
    //     const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    //     // Combine integer and decimal
    //     const formattedValue = decimalPart !== undefined
    //         ? `${formattedInteger}.${decimalPart}`
    //         : formattedInteger;

    //     // Update formData dynamically
    //     setFormData((prev) => ({
    //         ...prev,
    //         [field]: formattedValue,
    //     }));
    //     }
    // };

    const handlePackageProductChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, package_sku: selectedValues }));
    };

    // Handle size attribute change
    // const handleSizeChange = (index, field, value) => {
    //     const updatedSizes = [...formData.sizes];
    //     updatedSizes[index][field] = value;
    //     setFormData((prev) => ({ ...prev, sizes: updatedSizes }));
    // };
    const handleSizeChange = (index, field, value) => {
        setFormData((prev) => {
            const updatedSizes = [...prev.sizes];
            updatedSizes[index] = {
                ...updatedSizes[index],
                [field]: value,
            };

            const updatedSize = updatedSizes[index];

            const shouldDelete =
                updatedSize.id &&                     // must have id
                (updatedSize.name?.trim() === "" &&   // name empty
                updatedSize.price?.trim?.() === ""); // price empty

            return {
                ...prev,
                sizes: updatedSizes,
                deleted_sizes: shouldDelete
                    ? [...new Set([...prev.deleted_sizes, updatedSize.id])] // avoid duplicates
                    : prev.deleted_sizes,
            };
        });
    };

    // Add new size row
    const addSizeAttribute = () => {
        setFormData((prev) => ({
            ...prev,
            sizes: [...prev.sizes, { name: "", price: "" }],
        }));
    };

    // Remove size row
    // const removeSizeAttribute = (index) => {
    //     setFormData((prev) => ({
    //         ...prev,
    //         sizes: prev.sizes.filter((_, i) => i !== index),
    //     }));
    // };
    const removeSizeAttribute = (index) => {
        setFormData((prev) => {
            const sizeToRemove = prev.sizes[index];

            return {
                ...prev,
                deleted_sizes: sizeToRemove?.id
                    ? [...prev.deleted_sizes, sizeToRemove.id]
                    : prev.deleted_sizes,

                sizes: prev.sizes.filter((_, i) => i !== index),
            };
        });
    };

    useEffect(() => {
        Promise.all([
        retrievemisclist(),
        retrievepackagelist(),
        retrieverelatepackagelist(),
        retrievecategorylist(),
        getproductdetails(id)
        ])
        .then(() => {
        
        setIsLoading(false);
        })
    }, []);
 async function getproductdetails(id) {
        const response = await fetch(
          app_url+'smwwcommerceproduct/getproductdetails?id='+id,
          {
            method: "GET",
      
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )           
        const responsedata = await response.json();
          if(responsedata.data.msg === "Success") {
            const updatedForm = {
              ...formData,
              // country: '',
            product_name:responsedata.data.result.product_name,
            product_sku: responsedata.data.result.product_sku,
            product_price:responsedata.data.result.price,
            product_price1:responsedata.data.result.price1,
            product_price2:responsedata.data.result.price2,
            relate_misc:responsedata.data.result.relate_misc,
            product_type: responsedata.data.result.product_type,
            weight:responsedata.data.result.weight,
            product_url_slug:responsedata.data.result.slug,
            size: responsedata.data.result.size,
            sizes: [{ name: "",id: "", price: "" }],
            size_chart: responsedata.data.result.size_chart,
            package_sku:[],
            relate_package:responsedata.data.result.relate_package,
            product_status: responsedata.data.result.status,
            disclaimer_editor:responsedata.data.result.disclaimer_editor,
            relate_categories:responsedata.data.result.relate_category,
            sizes:responsedata.data.sizes,
              id:id
            };
     
            setFormData(updatedForm);
           setSavedProductType(responsedata.data.result.product_type);
           setSavedFiles(responsedata.data.path);
     
          }
           
        }
    async function retrievemisclist() {
        const response = await fetch(
            app_url+'smwwcommerceproduct/getmisclist',
            {
                method: "GET",
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )           
        const responsedata = await response.json();
        if(responsedata.data.msg === "Success") {
            setMiscOptions(responsedata.data.result);
        }
    }
    async function retrievepackagelist() {
        const response = await fetch(
            app_url+'smwwcommerceproduct/getpackagelist',
            {
                method: "GET",
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )           
        const responsedata = await response.json();
        if(responsedata.data.msg === "Success") {
            setpackageOptions(responsedata.data.result);
        }
    }
    async function retrievecategorylist() {
        const response = await fetch(
            app_url+'smwwcommerceproduct/getapparelcategorylist',
            {
                method: "GET",
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )           
        const responsedata = await response.json();
        if(responsedata.data.msg === "Success") {
            setcategories(responsedata.data.result);
        }
    }
    async function retrieverelatepackagelist() {
        const response = await fetch(
            app_url+'smwwcommerceproduct/getrelatepackagelist',
            {
                method: "GET",
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )           
        const responsedata = await response.json();
        if(responsedata.data.msg === "Success") {
            setrelatepackage(responsedata.data.result);
        }
    }

    // const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    
    const [fileInputKey, setFileInputKey] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');

    const validTypes = [
        'image/png',
        'image/jpeg',
        'image/jpg',
        'image/gif'
    ];

    const maxSize = 128 * 1024 * 1024;

    const handleFileInputChange = (e) => {
        const files = Array.from(e.target.files);

        const validFiles = [];
        const invalidFiles = [];

        files.forEach(file => {
            const isValidType = validTypes.includes(file.type);
            const isValidSize = file.size <= maxSize;

            if (isValidType && isValidSize) {
            validFiles.push(file);
            } else {
            invalidFiles.push(file);
            }
        });

        if (invalidFiles.length > 0) {
            const names = invalidFiles.map(f => f.name).join(', ');
            setErrorMessage(
            <>
                <div>The selected file{invalidFiles.length > 1 ? 's' : ''} <i>{names}</i> cannot be uploaded.</div>
                <div>Only files with the following extensions are allowed: <i>png, jpg, jpeg</i>.</div>
            </>
            );
            setFileInputKey(prev => prev + 1);
            // Don't clear uploadedFiles here, to keep previously uploaded files
        } else {
            setErrorMessage('');
            setUploadedFiles(prevFiles => [...prevFiles, ...validFiles]);  // Append new files
        }
    };

    const removeFile = (index) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    };
    const removeSavedFile = (index,id) => {
        setSavedFiles(prev => prev.filter((_, i) => i !== index));
        setFormData(prev => ({
            ...prev,
            removed_imageids: [...(prev.removed_imageids || []), id]
        }));
    };
    
    // const fileInputRef = useRef(null);
    // const removeSavedFile = (index, id) => {
    //     setFormData(prev => ({
    //         ...prev,
    //         // Track all deleted image IDs
    //         removed_imageids: [...(prev.removed_imageids || []), id],
    //     }));

    //     setSavedFiles(prev => prev.filter((_, i) => i !== index));
        
    //     // Reset file input
    //     if (fileInputRef.current) fileInputRef.current.value = '';
    // };

    const productType = [
        { value: "1", label: "Course" },
        { value: "2", label: "Agent Initiation" },
        { value: "3", label: "Scout Initiation" },
        { value: "4", label: "Miscellaneous" },
        { value: "5", label: "Reenroll" },
        { value: "6", label: "Renewal" },
        { value: "7", label: "Conference" },
        { value: "8", label: "Package" },
        { value: "9", label: "Apparel" },
    ];

    const commonFields = ["product_name", "product_sku", "product_price", "product_type", "product_status"];

    const getAllowedFields = (type) => {
        const typeSpecificFields = {
            "1": ["product_price1", "product_price2"],
            "2": [],
            "3": [],
            "4": ["relate_misc", "disclaimer_editor"],
            "5": [],
            "6": [],
            "7": ["disclaimer_editor"],
            "8": ["package_sku", "relate_package"],
            "9": [
                "files", "relate_categories", "weight", "product_url_slug",
                "sizes", "size_chart", "disclaimer_editor"
            ],
        };

        return [...commonFields, ...(typeSpecificFields[type] || [])];
    };


    const validateForm = () => {
    const newErrors = {};

    
  // Regular expression for allowed price input (numbers, commas, dots)
  const priceRegex = /^[0-9.,]+$/;

    if (!formData.product_name) {
        newErrors.product_name = "Product Name is required.";
    }

    if (!formData.product_price) {
        newErrors.product_price = "Product price is required.";
    }

    if (!formData.product_type) {
        newErrors.product_type = "Please select a product type.";
    }

    if (!formData.product_status) {
        newErrors.product_status = "Please choose the product status.";
    }

    // Conditional validation
    if (savedProductType === 1 && !formData.product_price1) {
        newErrors.product_price1 = "Product price 1 is required.";
        if (!priceRegex.test(formData.product_price1)) {
            newErrors.product_price1 = "Product price 1 must contain only numbers.";
        }
    }

    if (savedProductType === 1 && !formData.product_price2) {
        newErrors.product_price2 = "Product price 2 is required.";
        if (!priceRegex.test(formData.product_price2)) {
            newErrors.product_price2 = "Product price 2 must contain only numbers.";
        }
    }

    if (savedProductType === 4 && !formData.relate_misc) {
        newErrors.relate_misc = "Please select a related miscellaneous product.";
    }
    
    if (savedProductType === 9 && !formData.files) {
        newErrors.files = "Please upload at least one file.";
    }

    if (savedProductType === 9 && !formData.relate_categories) {
        newErrors.relate_categories = "Please select a category.";
    }

    if (savedProductType === 9 && !formData.weight) {
        newErrors.weight = "Product weight is required.";
    }

    if (savedProductType === 9 && savedFiles.length === 0 && uploadedFiles.length === 0 && errorMessage === "") {
        newErrors.files = "Product Image(s) is required.";
    }
    if (savedProductType === 9 && formData.sizes) { 
        formData.sizes.forEach((size, index) => {
            if (size.price && size.price.trim() !== "") {
                if (!priceRegex.test(size.price)) {
                    newErrors.sizes = `Size #${index + 1} Price must contain only numbers.`;
                }
            }
        });
    }

    setErrors(newErrors);

    // Return whether form is valid
    return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const isValid = validateForm();
        if (!isValid) 
        {
            window.scrollTo(0, 0);
            return; 
        }

        const selectedType = formData.product_type;

        const valid = uploadedFiles.filter(
            (file) => validTypes.includes(file.type) && file.size <= maxSize
        );

        if (formData.relate_categories > 0 && savedFiles.length === 0 && uploadedFiles.length === 0) {
            setErrorMessage("Please upload at least one file.");
            window.scrollTo(0, 0);
            return;
        }

        const allowedFieldsNew = getAllowedFields(selectedType);
        const allowedFieldsOld = getAllowedFields(savedProductType);
        const commonFields = allowedFieldsNew.filter(field => allowedFieldsOld.includes(field));

        const filteredFormData = allowedFieldsNew.reduce((acc, key) => {
            acc[key] = commonFields.includes(key) ? formData[key] ?? "" : "";
            return acc;
        }, {});

        if (selectedType === "9") {
            filteredFormData.size = formData.size;
            filteredFormData.files = valid;
            setUploadedFiles(valid); 
        } else {
            setUploadedFiles([]); 
        }

        const filteredSizes = formData.sizes.filter(
            (size) =>
            size &&
            Object.values(size).some(
                (val) => val !== "" && val !== null && val !== undefined
            )
        );

        const cleanedFormData = { 
            ...formData, 
            sizes: filteredSizes, 
            deleted_sizes: formData.deleted_sizes,
        };

        //setFormData(cleanedFormData);

        //setFormData(filteredFormData);
       // setSavedData(filteredFormData);
        //setSavedProductType(selectedType);

        //setFileInputKey((prev) => prev + 1); // reset file input
        const postData = new FormData();
        
        uploadedFiles.forEach(file => postData.append('apparelfiles[]', file));
        postData.append('formData', JSON.stringify(cleanedFormData));
      
        const response = await fetch(app_url+'smwwcommerceproduct/editproductdetails', {
      method: 'POST',
      body: postData
      });
     const responsedata = await response.json();
      if(responsedata.data.msg === "Success") {
        navigate('/admin/smww-commerce/product-list', { state: { message: responsedata.data.result } });
         
               
        }
      if(responsedata.data.msg === "Error") {
        setErrors(responsedata.data.result);
      }
     
        window.scrollTo(0, 0);

        console.log("Form submitted:", filteredFormData);
        console.log("Uploaded files:", valid);
    };

    return (
    <>
        {isLoading ? (
            <Loading />
        ) : (
            <div id="main">
                <Helmet><title>Edit Product | SMWW</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div className="edit-product-container">
                       {Object.keys(errors).length > 0 && (
                            <div
                                className="set-message-error"
                                style={{
                                background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`,
                                padding: "10px 10px 10px 45px",
                                }}
                            >
                                {Object.values(errors).map((error, index) => (
                                <div key={index}>{error}</div>
                                ))}
                            </div>
                        )}
                        <form>
                            <div>
                                <div>
                                    <label>Product Name</label>
                                    <input 
                                        type="text" 
                                        id="product_name" 
                                        name="product_name" 
                                        value={formData.product_name ?? ""} 
                                        onChange={handleChange} 
                                        style={{width:"30%"}} 
                                    />
                                </div>
                                <div>
                                    <label>Product SKU</label>
                                    <input 
                                        type="text" 
                                        id="product_sku" 
                                        name="product_sku" 
                                        value={formData.product_sku ?? ""} 
                                        onChange={handleChange} 
                                        disabled 
                                        style={{backgroundColor: "#fff"}}
                                    />
                                </div>
                                <div>
                                    <label>Product Price</label>
                                    <input 
                                        type="number" 
                                        name="product_price" 
                                        id="product_price" 
                                        value={formData.product_price ?? ""}
                                        onChange={handlePriceChange} 
                                        // onChange={(e) => handleNumberLikeChange("product_price", e.target.value)}
                                        style={{width: "177px"}}
                                    />
                                    <span style={{marginLeft: "5px"}}>USD</span>
                                </div>
                                {savedProductType === 1 && (
                                    <>
                                        <div>
                                            <label>Product Price1</label>
                                            <input
                                                type="text"
                                                name="product_price1"
                                                id="product_price1"
                                                value={formData.product_price1 ?? ""}
                                                onChange={handlePriceChange} 
                                                // onChange={(e) => handleNumberLikeChange("product_price1", e.target.value)}
                                            />
                                            <span style={{marginLeft: "5px"}}>USD</span>
                                        </div>
                                        <div>
                                            <label>Product Price2</label>
                                            <input 
                                                type="text" 
                                                name="product_price2" 
                                                id="product_price2" 
                                                value={formData.product_price2 ?? ""}
                                                onChange={handlePriceChange} 
                                                // onChange={(e) => handleNumberLikeChange("product_price2", e.target.value)}
                                            />
                                            <span style={{marginLeft: "5px"}}>USD</span>
                                        </div>
                                    </>
                                )}
                                
                                {savedProductType === 4 && (
                                    <div>
                                        <label>Relate Miscellaneous Product <span class="form-required">*</span></label>
                                        <select 
                                            id="relate_misc" 
                                            name="relate_misc"
                                            value={formData.relate_misc ?? ""}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">-Select-</option>
                                            {miscOptions.map((opt) => (
                                                <option key={opt.value} value={opt.value}>
                                                    {opt.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                                <div>
                                    <label>Product Type <span className="form-required">*</span></label>
                                    <select 
                                        id="product_type" 
                                        name="product_type"
                                        value={formData.product_type ?? ""}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">-Select-</option>
                                        {productType.map((type) => (
                                            <option key={type.value} value={type.value}>
                                            {type.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                
                                {savedProductType === 9 && (
                                    <>
                                    <div>
                                        <div>
                                            <label htmlFor="files">Product Image(s)</label>
                                            <input
                                                type="file"
                                                id="files"
                                                name="files"
                                                multiple
                                                onChange={handleFileInputChange}
                                                key={fileInputKey}
                                            />
                                            <p className="help-text">
                                                To add more than one image, hold down ctrl and select as many as you
                                                want
                                            </p>
                                        </div>
                                        {errorMessage && (
                                            <div 
                                                style={{ 
                                                    color: "red", 
                                                }}
                                            >
                                                {errorMessage}
                                            </div>
                                        )}
                                        {uploadedFiles.length > 0 && (
                                            <>
                                                {uploadedFiles.map((file, index) => (
                                                    <div key={index}>
                                                        <span className="file">
                                                            <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                                                            {file.name}
                                                            </a>
                                                        </span>
                                                        {/* <span> ({(file.size / 1024).toFixed(2)} KB)</span> */}
                                                        <button
                                                            type="button"
                                                            style={{border: "0px", color: "red", background: "#f6f5f5", cursor:"pointer"}}
                                                            onClick={() => removeFile(index)}
                                                        >
                                                            Remove
                                                        </button>
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                        {savedFiles.length > 0 && (
                                            <>
                                                {savedFiles.map((file, index) => (
                                                    <div key={index}>
                                                        <span className="file">
                                                            <a href={file.path} target="_blank" rel="noreferrer">
                                                            {file.name}
                                                            </a>
                                                        </span>
                                                        {/* <span> ({(file.size / 1024).toFixed(2)} KB)</span> */}
                                                        <button
                                                            type="button"
                                                            style={{border: "0px", color: "red", background: "#f6f5f5", cursor:"pointer"}}
                                                            onClick={() => removeSavedFile(index,file.id)}
                                                        >
                                                            Remove
                                                        </button>
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                    </div>
                                    <div>
                                        <label>Select Category</label>
                                        <select 
                                            id="relate_categories" 
                                            name="relate_categories"
                                            value={formData.relate_categories ?? ""}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">-Select-</option>
                                            {categories.map((cat) => (
                                                <option key={cat.value} value={cat.value}>
                                                    {cat.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label>Product Weight</label>
                                        <input
                                            className="input-medium"
                                            type="number"
                                            id="weight"
                                            name="weight"
                                            step="any"
                                            value={formData.weight ?? ""}
                                            onChange={handleChange}
                                            style={{width: "177px"}}
                                            required
                                        />
                                        <span style={{marginLeft: "5px"}}>lbs</span>
                                    </div>
                                    <div>
                                        <label>Url Slug</label>
                                        <input 
                                            type="text" 
                                            name="product_url_slug" id="product_url_slug" 
                                            value={formData.product_url_slug ?? ""} 
                                            onChange={handleChange} 
                                            disabled 
                                            style={{backgroundColor: "#fff"}} 
                                        />
                                    </div>
                                    <div>
                                        <label style={{fontWeight:"normal"}}>
                                            <input
                                                type="checkbox"
                                                name="size"
                                                checked={formData.size}
                                                onChange={handleChange}
                                            />
                                            Enable Size
                                        </label>
                                    </div>
                                    <div>
                                        {formData.size && (
                                            <div>
                                                <a
                                                    href="#"
                                                    className="add-size-link"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        addSizeAttribute();
                                                    }}
                                                >
                                                    + Add Size Attribute
                                                </a>
                                                <table>
                                                    <tbody>
                                                        {/* {formData.sizes.map((size, index) => ( */}
                                                        {Array.isArray(formData.sizes) && formData.sizes.map((size, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    Size:
                                                                    <input
                                                                        type="text"
                                                                        value={size.name ?? ""}
                                                                        onChange={(e) =>
                                                                            handleSizeChange(index, "name", e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    Price:
                                                                    <input
                                                                        type="text"
                                                                        value={size.price ?? ""}
                                                                        onChange={(e) =>
                                                                            handleSizeChange(index, "price", e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="#"
                                                                        className="remove-size-link"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            removeSizeAttribute(index);
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src="/basic/web/images/delete_icon.png"
                                                                            alt="Remove"
                                                                            className="remove-icon"
                                                                        />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                
                                                <label>Size Chart</label>
                                                <Editor
                                                    value={formData.size_chart || defaultTable}
                                                    onChange={(e) =>
                                                        onEditorChange("size_chart", e.target.value)
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                    </>
                                )}
                                
                                {savedProductType === 8 && (
                                    <>
                                        <div>
                                            <label>Package product</label>
                                            <select 
                                                id="package_sku" 
                                                name="package_sku" 
                                                value={formData.package_sku ?? ""}
                                                onChange={handlePackageProductChange}
                                                multiple
                                            >
                                                <option value="">-Select-</option>
                                                {packageOptions.map((opt) => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label>Relate Package</label>
                                            <select 
                                                id="relate_package" 
                                                name="relate_package"
                                                value={formData.relate_package ?? ""}
                                                onChange={handleChange}
                                            >
                                                <option value="">-Select-</option>
                                                {relatepackage.map((opt) => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </>
                                )}

                                <div>
                                    <label>Product Status <span className="form-required">*</span></label>
                                    <select 
                                        id="product_status" 
                                        name="product_status"
                                        value={formData.product_status ?? ""}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="1">Active</option>
                                        <option value="2">Disabled</option>
                                    </select>
                                </div>
                                {(savedProductType === 7 || savedProductType === 4 || savedProductType === 9) && (
                                    <div>
                                        {savedProductType === 4 ? (
                                            <>
                                                <label>Note:</label>
                                                <textarea
                                                    name="disclaimer_editor"
                                                    style={{ width: "22%", height: "60px" }}
                                                    value={formData.disclaimer_editor ?? ""}
                                                    onChange={(e) => onEditorChange("disclaimer_editor", e.target.value)}
                                                />
                                            </>
                                            ) : (
                                            <>
                                                <label>{savedProductType === 9 ? "Product Description" : "Disclaimer"}</label>
                                                <Editor
                                                value={formData.disclaimer_editor ?? ""}
                                                onChange={(e) => onEditorChange("disclaimer_editor", e.target.value)}
                                                />
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                            <br />
                            <input 
                                type="submit" 
                                id="edit-submit" 
                                name="" 
                                value="Save product" 
                                style={{width:"155px", height: "30px"}} 
                                className="form-submit"  onClick={handleSubmit}
                            />
                            <a className="form-submit delete-product" href={`/admin/smww-commerce/product-delete/${id}`}>Delete Product</a>
                        </form>
                    </div>
                </div>
                <div className="right">
                    <SalespersonSidebar />
                </div>
            </div>
        )}
    </>
    );
};
export default EditProduct;